<template>
    <div style="padding-top:25%; padding-bottom:25%" class="tc ba b--dashed b--yellow pointer" @click="$emit('click')">
        <img class="w-50" :src="image"/>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: String
        }
    }
};
</script>
